import { render } from "./AuthModal.vue?vue&type=template&id=409abe34&scoped=true&ts=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"

import "./AuthModal.vue?vue&type=style&index=0&id=409abe34&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409abe34"]])

export default __exports__